import { PASSWORD_POLICY_REGEX } from './regex';

export const findRequiredFields = (prefix: string, fields: any) => {
	return Object.keys(fields).reduce((prev: any, current: string) => {
		if (fields[current].tests?.findIndex(({ name }: any) => name === 'required') >= 0) {
			prev[prefix ? prefix + '.' + current : current] = true;
		}
		if (fields[current].fields) {
			const nested = findRequiredFields(current, fields[current].fields);
			prev = { ...prev,  ...nested };
		}
		return prev;
	}, {});
};

export const validatePasswordPolicy = (password: string) => {
  return {
    hasMinLength: PASSWORD_POLICY_REGEX.MIN_LENGTH.test(password),
    hasUppercase: PASSWORD_POLICY_REGEX.UPPERCASE.test(password),
    hasLowercase: PASSWORD_POLICY_REGEX.LOWERCASE.test(password),
    hasNumber: PASSWORD_POLICY_REGEX.NUMBER.test(password),
    hasSpecialChar: PASSWORD_POLICY_REGEX.SPECIAL_CHAR.test(password),
    isValid: 
      PASSWORD_POLICY_REGEX.MIN_LENGTH.test(password) &&
      PASSWORD_POLICY_REGEX.UPPERCASE.test(password) &&
      PASSWORD_POLICY_REGEX.LOWERCASE.test(password) &&
      PASSWORD_POLICY_REGEX.NUMBER.test(password) &&
      PASSWORD_POLICY_REGEX.SPECIAL_CHAR.test(password)
  };
};